// extracted by mini-css-extract-plugin
module.exports = {"title":"_c2a200a7"};